import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { Grid, Heading, HeadingSize, IconName, Text } from '@as/cotopaxi';
import { StoreInfoTag } from './StoreInfoTag';
import { Box, Stack } from '@yonderland/andes-react';
const StoreDepartments = ({ departments }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    if (!departments || departments.length === 0) {
        return null;
    }
    return (_jsx(Box, { paddingBlock: { base: '3', lg: '5' }, children: _jsxs(Stack, { direction: "col", gap: "3", children: [_jsx(Heading, { size: HeadingSize.XL, children: t('store.storedepartments.txt') }), _jsx(Grid, { columns: { mobile: 1, tablet: 2, desktop: 3 }, rows: { tablet: 7 }, gap: "s", flow: { mobile: 'row', tablet: 'column' }, children: departments.map(department => (_jsx(StoreInfoTag, { icon: IconName.CHEVRON_RIGHT, children: _jsx(Text, { inline: true, children: t(`store.department.${department.code}`) }) }, department.code))) })] }) }));
};
export default StoreDepartments;
